import React, { useState, useEffect } from 'react'
import { StackedBarChart } from "@carbon/charts-react";
import TableToolbarDownload from '../../common/TableToolbarDownload';
import * as DashboardConstants from './DashboardConstants'

const DashboardStackedBarChart = (props) => {
    const defaultStackedGraphOptions = {
        "axes": {
            "left": {
                "mapsTo": "value",
                "stacked": true
            },
            "bottom": {
                "title": DashboardConstants.Time,
                "mapsTo": "key",
                "scaleType": "labels"
            }
        },
        "legend": {
            "position": "top",
            "orientation": "horizontal",
            "alignment": "right"
        },
        "data": {
            "loading": props.loading
        },
        "height": "400px"
    };

    const stackedGraphHeaders = [{ key: 'group', header: DashboardConstants.Group }, { key: 'key', header: DashboardConstants.Date },
    { key: 'value', header: DashboardConstants.Value }];

    return (
        <>
            {!defaultStackedGraphOptions.data.loading && !props.stackedBarChartData.length ?
                <div>{DashboardConstants.NoDataAvailable}</div>
                :
                <div className="dashboard-stacked-bar-chart">
                    <div className="graph-title carbon-display-Regular-20">
                        <div>{props.title}</div>
                        <div className="download-button">
                            <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={props.stackedBarChartData} headers={stackedGraphHeaders} title={props.title} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                        </div>
                    </div>
                    <StackedBarChart
                        data={props.stackedBarChartData}
                        options={defaultStackedGraphOptions}>
                    </StackedBarChart>
                </div>
            }
        </>
    );
};

export default DashboardStackedBarChart;
